import { Pipe, PipeTransform } from '@angular/core';
import { SubscriberRelationship } from '@rivethealth/data/patient';

@Pipe({ name: 'subscriberRelationship' })
export class SubscriberRelationshipPipe implements PipeTransform {
  transform(value: SubscriberRelationship): string {
    switch (value) {
      case 'self':
        return 'Self';
      case 'parent':
        return 'Parent';
      case 'child':
        return 'Child';
      case 'domestic_partner':
        return 'Domestic partner';
      case 'spouse':
        return 'Spouse';
      case 'other':
        return 'Other';
      case 'unknown':
        return 'Unknown';
    }
  }
}
